import moment from "moment-timezone";
import { Type } from "@shared/ui/Type";
import { PhaseAction } from "@platform/types/platform.types";
import { ProgramPhaseActionItemContainer } from "./ProgramPhaseActionItemContainer";
import { ProgramPhaseActionItemPlaceholder } from "./ProgramPhaseActionItemPlaceholder";
import { twMerge } from "tailwind-merge";

type Props = {
  actions: PhaseAction[];
  isLoading: boolean;
};

export function ProgramPhaseActionList({ actions, isLoading }: Props) {
  const completedActions = actions?.filter(
    (a) => a.status === "completed"
  ).length;

  const isLoadedAndNoActions = !actions || (!isLoading && actions.length === 0);

  return (
    <div
      className={twMerge(
        "flex flex-col border border-brand-800 rounded-lg gap-4 py-6 md:p-6 overflow-x-hidden h-full",
        isLoadedAndNoActions && "md:pt-6"
      )}
    >
      <div className="flex flex-col gap-1 px-6 md:px-0">
        <Type variant={isLoadedAndNoActions ? "h6" : "h5"}>
          {actions && actions.length
            ? `Actions (${completedActions} of ${actions.length} complete)`
            : isLoading
            ? "Loading actions..."
            : "No actions required for this phase"}
        </Type>
      </div>
      {actions && actions.length ? (
        <div className="flex flex-col gap-2">
          {actions.map((action, idx) => {
            let isDisabled = false;

            isDisabled =
              moment().isBefore(moment(action.available_date)) ||
              moment().isAfter(moment(action.closed_date));

            return (
              <ProgramPhaseActionItemContainer
                key={`${action.name}-${idx}`}
                disabled={isDisabled}
                action={action}
              />
            );
          })}
        </div>
      ) : (
        isLoading && (
          <>
            {Array.from({ length: 3 }).map((_, index) => (
              <ProgramPhaseActionItemPlaceholder key={index} />
            ))}
          </>
        )
      )}
    </div>
  );
}

export default ProgramPhaseActionList;
